import { ensureModuleMessages, registerModuleCatalog } from '@/shared/i18n/i18n';
import type { Locale } from '@/shared/i18n/locales';

// Catálogo do módulo (U33), carregado com a casca (`eager`): o título do manifesto aparece no menu, no
// ⌘K e no breadcrumb antes de a tela abrir.
registerModuleCatalog('bank-account', (locale: Locale) => import(`./locales/${locale}.po`), { eager: true });

export const loadBankAccountMessages = () => ensureModuleMessages('bank-account');
